import { render } from "./ProjectCancelAttachmentModal.vue?vue&type=template&id=b46efd10&scoped=true&ts=true"
import script from "./ProjectCancelAttachmentModal.ts?vue&type=script&lang=ts"
export * from "./ProjectCancelAttachmentModal.ts?vue&type=script&lang=ts"

import "./ProjectCancelAttachmentModal.scss?vue&type=style&index=0&id=b46efd10&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b46efd10"]])

export default __exports__